module.exports = __webpack_public_path__ + "img/tuan4-1.9422157d.png";